export default __webpack_public_path__ + "static/calidad-de-los-alumnos-mobile-27e4d6a56804b32ff7ad8c4ad4af34b9.svg";